<template>
    <div>
        <label class="titleLabel">热门问题排行榜</label>
        <hr class="titleHr">
        <a-table :dataSource="dataSource" :columns="columns">
          <template #rank="{ text }">
            <img v-if="text == 1" src="@/assets/ic-排名第1.svg">
            <img v-else-if="text == 2" src="@/assets/ic-排名第2.svg">
            <img v-else-if="text == 3" src="@/assets/ic-排名第3.svg">
            <label v-else>{{ text }}</label>
          </template>
        </a-table>
    </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useI18n } from "@/i18nPlugin";
import { 
    getHotQuestionTopData
} from '../../api/index';
var moment = require('moment')

export default defineComponent({
    props: {
        watchData: Object
    },
    setup() {
        const i18n = useI18n();
        const token = localStorage.getItem("userToken");
        const getHotQuestionTop = (n) => {
            if(n.tag == 'day') {
                getHotQuestionTopData({
                    startTime: n.dayStart ? moment(n.dayStart).format("YYYY-MM-DD") : n.dayStart,
                    endTime: n.dayEnd ? moment(n.dayEnd).format("YYYY-MM-DD") : n.dayEnd
                },token).then(res => {
                    dataSource.value = res.data;
                    console.log(res.data)
                }).catch(error => {
                    console.log(error)
                });
            }else if(n.tag == 'month'){
                getHotQuestionTopData({
                    startTime: n.monthStart ? moment(n.monthStart).format("YYYY-MM-DD") : n.monthStart,
                    endTime: n.monthEnd ? moment(n.monthEnd).format("YYYY-MM-DD") : n.monthEnd
                },token).then(res => {
                    dataSource.value = res.data;
                    console.log(res.data)
                }).catch(error => {
                    console.log(error)
                });
            }
        }
        const columns = ref([
          {
            title: '排名',
            dataIndex: 'rank',
            key: 'rank',
            width:20,
            align: 'center',
            slots: {
              customRender: 'rank',
            },
          },
          {
            title: 'ErrorCode',
            dataIndex: 'errorCode',
            key: 'errorCode',
            ellipsis: true,
            width:35
          },
          {
            title: '标题',
            dataIndex: 'title',
            key: 'title',
            ellipsis: true,
            width:40
          },
          {
            title: '访问量',
            dataIndex: 'count',
            key: 'count',
            width:25,
            align: 'center'
          }
        ])
        const dataSource= ref([]);
        return {
            i18n,
            columns,
            dataSource,
            getHotQuestionTop
        };
    },
    watch:{ 
        watchData:{
            handler(n,o){
                this.getHotQuestionTop(n);
                // console.log('echarts子组件中的参数： ' + n)
                // console.log(n.tag)
                // console.log(n.monthStart)
                // console.log(n.monthEnd)
                // console.log(n.dayStart)
                // console.log(n.dayEnd)
            },
            deep:true// 深度监听父组件传过来对象变化
        }
    }
})
</script>
    
<style scoped>
    .titleLabel {
      display: block;
      font-size: 16px;
      font-weight: bold;
      padding: 10px 0px 5px 20px;
    }
    .titleHr {
      border: 1px solid #e2e4e6;
    }
</style>